<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <p class="mb-0 configurator-label">
          <BlankIcon :field="blank" />
          {{ label }}
        </p>
        <p v-if="alertMsg" class="text-danger fs-14 mb-0 align-self-end ml-2">{{ alertMsg }}</p>
      </div>
      <slot name="text" />
      <button
        v-if="showReset && blank"
        type="button"
        class="btn p-0 m-0"
        @click="$emit('reset')"
      >
        <font-awesome-icon
          :icon="['far', 'times']"
          fixed-width
          size="lg"
          class="text-secondary mr-1"
        />
      </button>
    </div>
    <slot name="feedback" />
  </div>
</template>

<script>
import BlankIcon from './BlankIcon'

export default {
  name: 'Label',
  components: { BlankIcon },
  props: {
    label: {
      type: String,
      required: true
    },
    blank: {
      type: [String, Boolean, Number, undefined, null],
      required: false,
      default: 'y'
    },
    showReset: {
      type: Boolean,
      required: false,
      default: false
    },
    alertMsg: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
